import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BackButtonService } from 'src/app/services/biometrics/back-button.service';
import { BiometricsDataService } from 'src/app/services/biometrics/biometrics-data.service';
import { FILE_TYPE_PARAM } from 'src/app/shared/data/biometrics.constants';
import {
  EBiometricsType,
  EscreenKeys,
  IBiometricsInstructions
} from 'src/app/shared/interfaces/biometrics.interface';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-biometrics-instructions',
  templateUrl: './biometrics-instructions.component.html',
  styleUrls: ['./biometrics-instructions.component.scss']
})
export class BiometricsInstructionsComponent implements OnInit {
  instructions: IBiometricsInstructions[keyof IBiometricsInstructions];
  EBiometricsType = EBiometricsType;
  type: EBiometricsType;
  screenKey = EscreenKeys.INSTRUCTIONS;
  assetsUrl = environment.assetsUrl;
  constructor(
    private backButtonService: BackButtonService,
    private router: Router,
    public biometricsDataService: BiometricsDataService,
    private activatedRoute: ActivatedRoute
  ) {
    this.type = this.activatedRoute.snapshot.paramMap.get(
      FILE_TYPE_PARAM
    ) as EBiometricsType;
    this.instructions =
      this.biometricsDataService.biometricsInstructions[this.type];
  }

  ngOnInit() {
    this.backButtonService.checkScreen(this.type, this.screenKey);
  }

  continueFlow(): void {
    this.router.navigate([
      this.biometricsDataService.routingBiometrics[this.type][this.screenKey].to
    ]);
  }

  getIcon(): Object {
    return {
      'background-image':
        'url(' +
        this.assetsUrl +
        this.biometricsDataService.generalData[this.type].urlGif +
        ')',
      'background-blend-mode': 'screen, normal',
      'background-repeat': 'no-repeat',
      'background-position': 'center',
      margin: '0 auto'
    };
  }
}
